import { NgOptimizedImage } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ShowdownDirective } from '../../../directives/animations/showdown.directive';
import { ProductApiService } from '../../../services/apis/product-api.service';

@Component({
  selector: 'section[app-home-shop-by-movement]',
  imports: [NgOptimizedImage, ShowdownDirective, RouterModule, MatIconModule],
  templateUrl: './home-shop-by-movement.html',
  styleUrl: './home-shop-by-movement.scss',
})
export class HomeShopByMovement implements OnInit {
  tags = [
    {
      name: 'Train',
      image: '/images/home/veyora-category-train.webp',
      description: 'Supportive fits for lifting, circuits, and high-energy studio days.',
    },
    {
      name: 'Stretch',
      image: '/images/home/veyora-category-stretch.webp',
      description: 'Soft stretch pieces for yoga, barre, and slower rituals.',
    },
    {
      name: 'Layer',
      image: '/images/home/veyora-category-layer.webp',
      description: 'Light layers for warmups, cool-downs, and everywhere after.',
    },
  ];

  constructor(private productApi: ProductApiService) { }

  ngOnInit(): void {
    // this.findProductCategories();
  }



}
